import React from "react"
import { toMoney } from "../../utils/string_utils"
import "./summary-costs.scss"
import { PropTypes } from "prop-types"

const SummaryCosts = ({ costs, excludeVAT, vatDivider }) => {
  const vatAmount = Math.round((vatDivider - 1) * 100)
  return (
    <div className="summary-costs">
      {costs.vat > 0 && (
        <div className="cost">
          <span className="label">Total monthly VAT ({vatAmount}%)</span>:{" "}
          {toMoney(costs.vat)}
        </div>
      )}
      {costs.monthly > 0 && (
        <div className="cost">
          <span className="label">Total monthly cost</span>:{" "}
          {excludeVAT ? (
            <>
              {toMoney(costs.monthly * vatDivider)}
              <span className="vatDescription">
                ({toMoney(costs.monthly)} exc. VAT)
              </span>
            </>
          ) : (
            toMoney(costs.monthly)
          )}
        </div>
      )}
      {costs.upfront > 0 && (
        <div className="cost">
          <span className="label">Total upfront cost</span>:{" "}
          {excludeVAT ? (
            <>
              {toMoney(costs.upfront * vatDivider)}
              <span className="vatDescription">
                ({toMoney(costs.upfront)} exc. VAT)
              </span>
            </>
          ) : (
            toMoney(costs.upfront)
          )}
        </div>
      )}
    </div>
  )
}

SummaryCosts.propTypes = {
  costs: PropTypes.shape({
    monthly: PropTypes.number,
    vat: PropTypes.number,
    upfront: PropTypes.number
  }),
  excludeVAT: PropTypes.bool,
  vatDivider: PropTypes.number
}

export default SummaryCosts
